export const style = {
  boxContainer: {
    sx: {
      px: 3,
    },
  },
  tableRow: {
    sx: (isOpenRow: boolean) => {
      if (!isOpenRow) {
        return {
          display: 'none',
        };
      }

      return {
        display: 'table-row',
      };
    },
  },
  Collapse: {
    sx: {
      position: 'relative',
      borderLeft: '5px solid #6D6FE9',
    },
  },
  CollapseWrapper: {
    display: 'flex',
  },
  MatchFlowId: {
    paddingLeft: '24px',
    margin: '24px 0',
  },
  divider: {
    sx: {
      my: 2,
    },
  },
  TypographyH6: {
    sx: {
      color: 'primary.text',
      fontWeight: 600,
    },
  },
  tableCell: {
    sx: {
      px: 0,
      border: 0,
    },
  },
  box: {
    sx: {
      
    },
  },
  Typography: {
    sx: {
      maxWidth: '100%',
      whiteSpace: 'break-spaces',
      wordBreak: 'break-word',
      color: 'action.active',
    },
  },
} as const;
